// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
const flagsSVG = require.context('../styles/countryFlags', true, /\.svg$/);
flagsSVG.keys().map(flagsSVG);
const canvasImagesSVG = require.context('../styles/canvasImages', true, /\.svg$/);
canvasImagesSVG.keys().map(canvasImagesSVG);
const desktopSVG = require.context('../styles/WebDesktop/Desktop/SVG', true, /\.svg$/);
desktopSVG.keys().map(desktopSVG);
